import { render } from "./Carousel3d.vue?vue&type=template&id=1f748384&scoped=true"
import script from "./Carousel3d.vue?vue&type=script&lang=js"
export * from "./Carousel3d.vue?vue&type=script&lang=js"

import "./Carousel3d.vue?vue&type=style&index=0&id=1f748384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f748384"]])

export default __exports__